module.exports = __webpack_public_path__ + "img/bg-erw.69db7bea.png";